enum ExportType {
    "ORDER_TIME" = "ORDER_TIME",

    "PAYMENT_TIME" = "PAYMENT_TIME",

    "PRINTING_TIME" = "PRINTING_TIME",

    "SHIPPING_TIME" = "SHIPPING_TIME",

    "EXPORT_TIME" = "EXPORT_TIME",

    "SPECIFIED_ORDER" = "SPECIFIED_ORDER",

    "SPECIFIED_QUERY" = "SPECIFIED_QUERY",
}

export default ExportType;
